import React from 'react';

import TruncatedCardText from './TruncatedCardText';

interface ProductNameProps {
  productName?: string | null;
  isSelected?: boolean;
  maxChars?: number;
}

const ProductName: React.FC<ProductNameProps> = ({ productName, isSelected = false, maxChars = 30 }) => {
  return (
    <TruncatedCardText
      string={productName}
      typographyVariant="cardHeading"
      isSelected={isSelected}
      maxChars={maxChars}
    />
  );
};

export default ProductName;
